module.exports = __webpack_public_path__ + "img/additional-header-pt.9f89657c.png";